import { nextTheme, useTheme } from '../lib/theme';
import { t } from '../lib/i18n';
import type { Theme } from '../lib/theme';

const ICONS: Record<Theme, JSX.Element> = {
  // Sun
  light: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  ),
  // Moon
  dark: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  ),
  // Monitor (follow OS)
  system: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2" />
      <path d="M8 21h8M12 17v4" />
    </svg>
  ),
};

/** Cycles light → dark → system; the icon shows the current preference. */
export default function ThemeToggle() {
  const [theme, setTheme] = useTheme();
  const label = `${t.theme.label}: ${t.theme[theme]}`;
  return (
    <button
      type="button"
      onClick={() => setTheme(nextTheme(theme))}
      className="p-2 rounded text-tremor-content hover:text-tremor-content-strong hover:bg-tremor-background-muted"
      title={label}
      aria-label={label}
    >
      {ICONS[theme]}
    </button>
  );
}
